<template>
  <div>
    <div v-if="selectedCategories.length" class="modal-div">
      <v-list-item @click="clearAll">
        <v-list-item-content>
          <div class="d-flex justify-space-between">
            <span class="caption">Limpar todos</span>
            <span class="caption" :style="selectedCategoriesLabelStyle">({{ selectedCategoriesLabel }})</span>
          </div>
        </v-list-item-content>
      </v-list-item>
      <div class="scrollable-area">
        <div v-for="(category, categoryIndex) in selectedCategories" :key="`${category.id}-${categoryIndex}`" class="px-3">
          <v-chip class="body-2 mb-3" close-icon="close" close :disabled="category.disabled" @click:close="removeCategory(category)">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ category.id }} -
                  {{ category.name | truncate({ length: 20 }) }}
                </span>
              </template>
              <span>{{ category.name }}</span>
            </v-tooltip>
          </v-chip>
        </div>
      </div>
    </div>
    <div v-else>
      <v-alert class="ma-3" type="info" outlined> Selecione uma categoria </v-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectedCategories',
  props: {
    selectedCategories: {
      type: Array,
      default: () => [],
    },
    maxSelectableItems: {
      type: Number,
      default: () => 20,
    },
  },

  data: () => ({
    localSelectedCategories: [],
  }),

  computed: {
    selectedCategoriesLabel() {
      return `${this.selectedCategories?.length || 0} selecionadas`
    },
    selectedCategoriesLabelStyle() {
      return this.selectedCategories?.length > this.maxSelectableItems
        ? {
            color: '#FF5252',
          }
        : {}
    },
  },

  watch: {
    selectedCategories: {
      handler() {
        this.localSelectedCategories = this.selectedCategories
      },
      deep: true,
    },
  },

  mounted() {
    this.localSelectedCategories = this.selectedCategories
  },

  methods: {
    clearAll() {
      this.localSelectedCategories = []
      this.$emit('update:selected-categories', this.localSelectedCategories)
    },

    removeCategory(category) {
      this.localSelectedCategories = this.localSelectedCategories.filter((selectedCategory) => selectedCategory.id !== category.id)
      this.$emit('update:selected-categories', this.localSelectedCategories)
    },
  },
}
</script>

<style lang="scss" scoped>
.scrollable-area {
  max-height: 500px;
  overflow: auto;
}
</style>
